module.exports = __webpack_public_path__ + "static/media/identity.ad9fc387.svg";